import Chip from '@mui/material/Chip'
import { useTheme } from '@mui/material/styles'
import statusColor from '../utils/status-color'

type Props = {
  status: string
}

let getSx = (
  status: string,
  pendingColor: string,
  divider: string,
): object | undefined => {
  if (status === 'Pending') {
    return {
      color: pendingColor,
      borderColor: `color-mix(in srgb, ${pendingColor} 55%, ${divider})`,
    }
  }
  return undefined
}

let StatusChip = ({ status }: Props) => {
  let theme = useTheme()

  return (
    <Chip
      label={status}
      color={statusColor(status)}
      variant="outlined"
      size="medium"
      sx={getSx(
        status,
        theme.palette.analyticsColors.recordedCourses,
        theme.palette.divider,
      )}
    />
  )
}

export default StatusChip
